<template>
  <Row>
        <i-col span="12">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
            <FormItem label="真实姓名" prop="realname">
                <i-input v-model="formValidate.realname" placeholder="请输入真实姓名"></i-input>
            </FormItem>
            <FormItem label="电子邮箱" prop="email">
                <i-input v-model="formValidate.email" placeholder="Enter your e-mail"></i-input>
            </FormItem>
            <FormItem label="手机号码" prop="mobile">
                <i-input v-model="formValidate.mobile" placeholder="Enter your e-mail"></i-input>
            </FormItem>
            <FormItem label="密码" prop="password">
                <i-input type="password" v-model="formValidate.password"></i-input>
            </FormItem>
            <FormItem label="重复密码" prop="passwdCheck" v-if="passwdCheck()">
                <i-input type="password" v-model="formValidate.passwdCheck"></i-input>
            </FormItem>
            <FormItem label="角色" prop="role">
              <Select v-model="formValidate.role" multiple style="width:260px">
                <Option v-for="item in roleList" :value="item.id" :key="item.id">{{ item.name }}</Option>
             </Select>
            </FormItem>
            <FormItem label="是否超级管理员" prop="issupper">
                <RadioGroup v-model="formValidate.issupper">
                    <Radio label="1">是</Radio>
                    <Radio label="0">不是</Radio>
                </RadioGroup>
            </FormItem>   
            <FormItem>
                <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
            </FormItem>
        </Form>
        </i-col>
        <i-col span="12"></i-col>
    </Row>    
</template>
<script>
import { mapState } from 'vuex'
import { admindetail, updateadmin } from "../../api/adminapi";
export default {
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === "") {

        callback();
      } else {
        if (this.formValidate.passwdCheck !== "") {
          // 对第二个密码框单独验证
          this.$refs.formValidate.validateField("passwdCheck");
        }
        callback();
      }
    };
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formValidate.password) {
        callback(new Error("两次密码不同"));
      } else {
        callback();
      }
    };
    const validatemobile = (rule, value, callback) => {
      var reg = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error("手机格式错误"));
      }
    };
    return {
      params: this.$route.query,
      formValidate: {
        realname: "",
        email: "",
        mobile: "",
        role: "",
        issupper: "",
        password: "",
        passwdCheck: ""
      },
      ruleValidate: {
        realname: [
          {
            required: true,
            message: "The name cannot be empty",
            trigger: "blur"
          }
        ],
        email: [
          {
            required: true,
            message: "Mailbox cannot be empty",
            trigger: "blur"
          },
          { type: "email", message: "Incorrect email format", trigger: "blur" }
        ],
        mobile: [
          {
            required: true,
            message: "Please select the city",
            trigger: "blur"
          },
          { validator: validatemobile, trigger: "blur" }
        ],
        password: [{ validator: validatePass, trigger: "blur" }],
        passwdCheck: [{ validator: validatePassCheck, trigger: "blur" }]
      }
    };
  },
  computed: mapState({
    // 箭头函数可使代码更简练
    roleList: state => state.roleList,
    }),
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.updateadmin();
        } else {
          this.$Message.error("Fail!");
        }
      });
    },
    updateadmin() {
      let para = this.formValidate;
      para.id = this.params.id;
      debugger
      if(!this.formValidate.password||this.formValidate.password==''){
        delete para['password'];

      }
      if(!this.formValidate.passwdCheck||this.formValidate.passwdCheck==''){
        delete para['passwdCheck'];

      }
      this.$Loading.start();
      updateadmin(para).then(res => {
        this.$Loading.finish();
        var data = res.data;
        if (data.code == 1) {
          this.$Message.success(data.message);
          var _this=this
          setTimeout(function() {
            _this.$router.push({ path: "/adminlist" });
          }, 1500);
        } else {
           this.formValidate.password='';
          this.formValidate.passwdCheck=''
          this.$Message.error(data.message);
        }
      });
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    passwdCheck() {
      if (this.formValidate.password != "") {
        return true;
      } else {
        return false;
      }
    },
    setparams(id) {
      var data = {
        id: id
      };
      var _this = this;
      admindetail(data).then(res => {
        var Data = res.data;
        if (Data.code == 1) {
          let data = Data.data;
          _this.formValidate = {
            realname: data.realname,
            email: data.email,
            mobile: data.mobile,
            role:[],
            issupper: data.issupper + "",
            // password: data.password,
            // passwdCheck: data.passwdCheck
          };
        
          data.role.forEach(element => {
             _this.formValidate.role.push(element.id)
          });
        } else {
          this.$Message.error(Data.message);
        }
      });
    }
  },
  mounted() {
    if (this.$route.query && this.$route.query.id) {
      this.setparams(this.$route.query.id);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/updte.vue